import React from 'react'
import style from './ProductLocationsList.module.css'
import { Inventory } from '../../../../../assets/icons'
import { Translate } from '../../../../../language'
import TitleSVG from '../../../../../utils/components/TitleSVG/TitleSVG'
import Input from '../../../../../utils/components/Input/Input';
import Item from './Item'
import ListItems from './ListItems'

const ProductLocationsList = ({ inventoryProducts, skip, setSkip, limit, setSearch, onClickRow,locationName, inventoryType }) => {

  const idTimeOuts = [];

  const searchUser = (value) => {
    setSearch(value);
    clearTimeout(idTimeOuts[0]);
    idTimeOuts.length = 0;
  }

  const scrollPagination = (e) => {
    if (e.target.scrollTop + 1 >= e.target.scrollHeight - e.target.clientHeight) {
      setSkip(skip + limit);
    }
  }

  const onSearchValueChange = (e) => {
    let value = e.target.value;

    if (idTimeOuts.length ===0) {
      idTimeOuts.push(setTimeout(() => { searchUser(value) }, 1000));
    }

    else {
      clearTimeout(idTimeOuts[0]);
      idTimeOuts.shift();
      idTimeOuts.push(setTimeout(() => { searchUser(value) }, 1000));
    }
  }
  return (

    <div>
      <div className={style.record_container}>
        <TitleSVG Icon={Inventory}
          titleHighlight={Translate('productLocationsListTitleHighlight', 'es')}
          title={Translate('productLocationsListTitle', 'es') + locationName} />

        <div className={style.record_grid_container}>
          <div className={style.record_grid} onScroll={scrollPagination}>
            <div className={style.record_grid_title}>código</div>
            <div className={style.record_grid_title}>nombre</div>
            <div className={style.record_grid_title}>cantidad</div>
            <div className={style.record_grid_title}>categoría</div>
            <div className={style.record_grid_title}>sub-categoría</div>
            {(inventoryType=='Location') ? <ListItems>
                {inventoryProducts.map(record => (
                   <Item
                    onClickRow={onClickRow}
                    key={record._id}
                    code={record.product[0].code}
                    name={record.product[0].name}
                    quantity={record.totalQuantityStock}
                    category={record.product[0].category.name}
                    subCategory={record.product[0].subcategory.name}
                    inventoryType={inventoryType}
                    id={record.product[0]._id}
                  />
                
                ))}
            
            </ListItems>: <ListItems>
                {inventoryProducts.map(record => (
                   <Item
                    onClickRow={onClickRow}
                    key={record._id}
                    code={record.productId.code}
                    name={record.productId.name}
                    quantity={record.stocks}
                    category={record.productId.categoryId.name}
                    subCategory={record.productId.subcategoryId.name}
                    inventoryType={inventoryType}
                    id={record.productId._id}
                  />
                
                ))}
            
            </ListItems>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductLocationsList